import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import landing from './landing'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    landing,
  },
}
